module.exports = __webpack_public_path__ + "media/images/icon_lock_open-c9627928caaaa505ac7de2a64bd065ec.svg";